export default __webpack_public_path__ + "static/media/guide_strips.34713b05.webp";